import { TextField } from '@mui/material';
import { useEffect, useRef, type ChangeEvent } from 'react';
import { TbIcon } from 'components/Figma';
import { tbColors } from 'styles/colors/tbColors';
import { cn } from 'utils/classNamesTailwind';
import { selectSearchVariants } from './selectVariants';

interface SelectSearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  mode?: 'flat' | 'tree';
  autoFocus?: boolean;
  open?: boolean;
  className?: string;
}

export function SelectSearchInput({
  value,
  onChange,
  placeholder = undefined,
  mode = 'flat',
  autoFocus = false,
  open = false,
  className = undefined,
}: SelectSearchInputProps) {
  const inputRef = useRef<HTMLInputElement>(null);
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => onChange(event.target.value);

  useEffect(() => {
    if (open && autoFocus) {
      inputRef.current?.focus();
    }
  }, [autoFocus, open]);

  return (
    <div className={cn(selectSearchVariants({ mode }), className)}>
      <TextField
        inputRef={inputRef}
        fullWidth
        size="small"
        placeholder={placeholder}
        value={value}
        onChange={handleChange}
        sx={{
          '& .MuiOutlinedInput-notchedOutline': { borderColor: '#e6e6e6', borderWidth: '1px' },
          '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#1a1a1a' },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#1a1a1a' },
          '& .MuiInputBase-root': {
            height: 40,
            paddingLeft: 2,
            paddingRight: 2,
          },
          '& .MuiInputBase-input': {
            fontSize: 14,
            fontWeight: 300,
          },
          '& .MuiInputBase-input::placeholder': {
            fontSize: 14,
            fontWeight: 300,
            color: tbColors.all.ash[400],
            opacity: 1,
          },
        }}
        InputProps={{
          startAdornment: <TbIcon name="MagnifyingGlass" size="sm" className="mr-2 h-6 w-6 text-ash-500" />,
        }}
      />
    </div>
  );
}
